import { Result } from 'true-myth';

export class CopyItemsError extends Error {
    constructor(
        readonly copiedIds: readonly string[],
        cause: unknown,
    ) {
        super(cause instanceof Error ? cause.message : 'Failed to copy items', { cause });
    }
}

export const copyItemsResult = (
    items: readonly { readonly id: string }[],
    results: readonly PromiseSettledResult<Result<unknown, Error>>[],
): Result<unknown, Error> => {
    const failure = results.find((result) => result.status === 'rejected' || result.value.isErr);
    if (failure === undefined) {
        return Result.ok(results.flatMap((result) => (result.status === 'fulfilled' ? [result.value] : [])));
    }
    const copiedIds = items.flatMap((item, index) => {
        const result = results[index];
        return result?.status === 'fulfilled' && result.value.isOk ? [item.id] : [];
    });
    const cause =
        failure.status === 'rejected' ? failure.reason : failure.value.isErr ? failure.value.error : undefined;
    return Result.err(new CopyItemsError(copiedIds, cause));
};
